export default __webpack_public_path__ + "static/media/Gellix-ThinItalic.f53bb7bf.woff";